import { Chance as C } from 'chance'
import { clamp } from 'lodash'

export default class Chance {
  static seed: string = Math.random().toString()

  static get double() {
    const n = new C(Chance.seed).floating({ min: 0, max: 1 })
    Chance.next()
    return n
  }

  static get int() {
    const n = new C(Chance.seed).integer()
    Chance.next()
    return n
  }

  static get bool() {
    return this.range(0, 1) > 0
  }

  static range(min: number, max: number) {
    const n = new C(Chance.seed).integer({ min, max })
    Chance.next()
    return n
  }

  static upto(max: number) {
    return Chance.range(0, max)
  }

  static exists(chance: number) {
    return chance >= Chance.double
  }

  static in<T>(...items: T[]) {
    return items[Chance.range(0, items.length - 1)]
  }

  // Fisher-Yates shuffle
  static shuffle<T>(list: T[]) {
    let n = list.length
    while (n --> 1) {
      const k = Chance.upto(n)
      const value = list[k]
      list[k] = list[n]
      list[n] = value
    }
    return list
  }

  static weighted<T>(list: T[], weights: number[]) {
    const totalWeight = weights.reduce((a, b) => a + b, 0)
    const randomNum = Chance.range(0, totalWeight)
    let weightSum = 0

    return list.find((item, i) => {
      weightSum += Math.max(weights[i], 0)
      return randomNum <= weightSum
    })!
  }

  static next() {
    Chance.seed = new C(Chance.seed).string()
    return Chance.seed
  }
}
